<template>
  <div class="news">
    <div class="news-section" v-loading="loading">
      <div class="news-section-content">
        
        <div class="content-nav-item">
          <div class="item-list" v-for="(item,index) in newsList" :key="index" @click="openLink(item.url)">
           
              <div class="item-img" >
                <img :src="imgserver + item.Img" alt="Dynamic Image" style="margin-top: 20px;">
              </div>

              <p class="item-list-title">{{item.Title}}</p>
              <p class="item-list-content">{{item.Content}}</p>
             
           
          </div>
        </div>
      </div>
    </div>
    <Bottom></Bottom>
  </div>
</template>

<script>
import Bottom from "../components/Bottom"; 
export default {
  name: "news",
  components: {
    Bottom
  },
  data() {
    return {
      loading: true,
      newsList: [],
     
    };
  },
  computed: {
  
  },
  methods: {
    loadData() {
      this.loading = true;
      this.$http
        .get(`/gw/Project/Project/`)
        .then(response => {
          //console.log(response);
          this.newsList = response.data;
          this.loading = false;
          //window.console.log(this.newsList);
        })
        .catch(function(error) {
          window.console.log(error);
        });
    },
    openLink(url) { 
      console.log(url);
      
      if (!url) { 
        return;
      }
      window.open(url , "_blank)");
    }
  },
  mounted() {
    this.loadData();
  }
};
</script>

<style lang="scss" scoped>
* {
  margin: 0;
  padding: 0;
}
.news {
  width: 100%;
  height: 100%;
  background-color: #343553;
  position: relative;
  overflow: hidden;

  .news-section{
    height: 79vh;
  }
  .page-div{
    text-align: center;
    font-size: 18px;
    color: #666;
    button{
      font-size: 18px;
      padding: 10px 30px;
      margin: 0 20px;
      border: 1px #bfbfbf solid;
      border-radius: 0;
      margin: 20px 5px;
      text-transform: uppercase;
      display: inline-block;
      padding: 5px 14px;
      background-color: #343553;
      border: 1px solid #ddd;
      border-radius: 5px;
    }
  }

  &-section {
    width: 100%;
    //height: 1600px;

    &-content {
      //width: 1240px;
      //height: 1600px;
      margin: 0 auto;
      background-color: #343553;
     // border: 1px solid red;

      .content-nav {
        width: 400px;
        height: 55px;
        margin: 0 auto;
        display: flex;
        //justify-content: center;
        align-items: center;
        position: relative;
        bottom: 30px;
        border: 1px solid wheat;
        
        &-btn {
          width: 100%;
          height: 100%;
          display: flex;
          align-items: center;
          justify-content: center;
          background-color: #e4e4e4;
          transition: all 0.2s;
        }

        .content-nav-active {
          font-size: 18px;
          color: #666;
        }
      }

      .content-nav-item {
        margin: 0 auto;
        display: flex;
        justify-content: flex-start;
        flex-wrap: wrap;
        //border: 1px solid blue;
        display: flex;
        justify-content: center;
        .item-list {
          width: 200px;
          height: 320px;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          margin: 100px 10px;
          border: 2px solid #4EABC8;
          border-top: 5px solid #4EABC8;
          border-radius: 5px;

          &:hover {
            border: 1px solid #343553;
            box-shadow: 0 0 5px 2px #bfd3e0;
          }
          .item-img {
            width: 100%;
            height: 100%;
            background-color: #cecece;
            background-repeat: no-repeat;
            background-size: cover;
            background-position: center;
            background-origin: content-box;
            text-align: center;
          }

          &-title {
            width: 80%;
            height: 120px;
            color: #fff;
            font-size: 22px;
            padding: 0 10px;
            margin: 20px 0;
            overflow: hidden;
            text-overflow: ellipsis;
            //border-left: 1px solid #15669e;
            text-align: center;
          }

          &-content {
             width: 100%;
            height: 100px;
            font-size: 14px;
            color: gray;

            // 文本长度处理 begin
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 5;
            -webkit-box-orient: vertical;
            white-space: normal !important;
            word-wrap: break-word;
            // 文本长度处理 ending
          }

          &-more {
             width: 100%;
            padding-top: 20px;
            display: flex;
            justify-content: flex-start;
            align-items: center;

            img {
              width: 12px;
              height: 12px;
            }
            span {
              color: #e13834;
              padding: 0 5px;
            }
          }
        }
      }
    }
  }
  .text-decoration {
    text-decoration: none;
  }
}
</style>